'use client';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef } from 'react';
import { getIsPadWidth } from '@elem/utils/devices';

export default function WidgetsItemEcoCreditsWin({ iconUrl }: any) {
    //const [isOpenA, setIsOpenA] = useState(false);
    const isMobile = getIsPadWidth();
    const isOpenB = useRef(false);
    // 切换
    const toggleHandle = () => {
        const isOpenA = !isOpenB.current;
        if (!isOpenA) {
            //关闭
            gtm.push({
                __btn_type: 'common',
                __btn_id1: 'WidgetsItem-EcoCreditsWin',
                __btn_id2: 'EcoCreditsWin',
                event: 'uaEvent',
                event_name: 'floating_button',
            });
            EcoDesignEventsBus.emit('widgets-EcoCreditsWin-close-2');
        } else {
            //打开
            gtm.push({
                event: 'uaEvent',
                event_name: 'floating_button',
            });
            EcoDesignEventsBus.emit('widgets-EcoCreditsWin-open');
        }
        isOpenB.current = isOpenA;
    };

    const show = () => {
        const isOpenA = !isOpenB.current;
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
        });
        EcoDesignEventsBus.emit('widgets-EcoCreditsWin-open');
        isOpenB.current = isOpenA;
    };

    const hide = () => {
        const isOpenA = !isOpenB.current;
        gtm.push({
            __btn_type: 'common',
            __btn_id1: 'WidgetsItem-EcoCreditsWin',
            __btn_id2: 'EcoCreditsWin',
            event: 'uaEvent',
            event_name: 'floating_button',
        });
        EcoDesignEventsBus.emit('widgets-EcoCreditsWin-close-2');
        isOpenB.current = isOpenA;
    };

    useEffect(() => {
        EcoDesignEventsBus.on('widgets-EcoCreditsWin-close-1', () => {
            isOpenB.current = false;
        });
    }, []);

    return (
        <div
            className="WidgetsItem WidgetsItem-EcoCreditsWin GtmModuleData-btn-common"
            onClick={isMobile ? toggleHandle : undefined}
            onPointerEnter={isMobile ? undefined : show}
            onPointerLeave={isMobile ? undefined : hide}
            data-btn-id="EcoCreditsWin"
        >
            <div className="WidgetsItem-icon">
                {/* <Icon /> */}
                <EcoImg pc={iconUrl}></EcoImg>
            </div>
        </div>
    );
}
